import styled from "styled-components";
import { Table } from "antd";

interface IProps {
    active?: boolean;
    disabled?: boolean;
}

export const SettingsContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: ${({ disabled, active }: IProps) =>
        disabled ? "#62936126" : active ? "#629361" : "#FFFFFF"};
    height: 100%;
    cursor: ${({ disabled }: IProps) =>
        disabled ? "not-allowed" : "pointer"} !important;
    * {
        cursor: ${({ disabled }: IProps) =>
            disabled ? "not-allowed" : "pointer"} !important;
    }
`;

export const SettingsMenu = styled.div<{
    active: boolean;
    settingsPosition?;
}>`
    position: absolute;
    padding: 15px 30px 24px 20px;
    z-index: 2;
    top: 0;
    ${({ settingsPosition }) =>
        settingsPosition === "right" ? "left:45px;" : "left: -225px;"}
    ${({ active }) => (active ? "" : "display:none;")}
    width: 225px;
    min-height: 68px;
    transition: all 0.3s;
    background: #629361;
    ${({ settingsPosition }) =>
        settingsPosition === "right"
            ? "border-radius: 0 10px 10px 10px;"
            : "border-radius: 10px 0 10px 10px;"}

    border-color: ${({ active }) => (active ? "none" : "none")};
`;

export const SettingsItems = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
`;
// 0 → rgb(210, 215, 53) [желтый]
// 1 → rgb(208, 152, 53) [оранжевый]
// 2 → rgb(208, 108, 53) [красно-оранжевый]
// 3 → rgb(190, 206, 209) [серый]
// 4 → rgb(174, 110, 110) [
export const getCellBackgroundWithErrorFlag = (errorFlag: number): string => {
    switch (errorFlag) {
        case 0:
            return "#FFFFFF"; // White
        case 1:
            return "rgb(210, 215, 53)"; // Yellow 
        case 2:
            return "rgb(208, 152, 53)"; // Orange 
        case 3:
            return "rgb(208, 108, 53)"; // Red 
        case 4:
            return "rgb(190, 206, 209)"; // LightGray
        case 5:
            return "#B3D9FF"; // LightBlue
        case 6:
            return "rgb(174, 110, 110)"; // Pink
        default:
            return "#FFFFFF"; // White 
    }
};

export const SettingItem = styled.div`
    position: relative;
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;

    :nth-child(n + 2) {
        margin-top: 18px;
    }

    ::after {
        position: absolute;
        content: "";
        bottom: -9px;
        left: 0;
        width: 180px;
        height: 2px;
        background-color: #7cbe7b;
    }
`;



export const TableWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;
